import { createContext, useState, useEffect } from "react";
import {
  getUserData,
  getToken,
  clearAuthData,
} from "../../infrastructure/storage/tokenStorage";
import { AuthService } from "../../application/services/authService";

const authService = new AuthService();

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const validateAuth = async () => {
      const token = getToken();

      if (!token) {
        setUser(null);
        setLoading(false);
        setAuthChecked(true);
        return;
      }

      try {
        const result = await authService.getCurrentUser();

        if (result.success) {
          const storedUser = getUserData();
          setUser(storedUser || result.user);
        } else {
          clearAuthData();
          setUser(null);
        }
      } catch (error) {
        console.error("Auth validation error:", error);
        clearAuthData();
        setUser(null);
      } finally {
        setLoading(false);
        setAuthChecked(true);
      }
    };

    validateAuth();
  }, []);

  const updateUser = (newUser) => {
    setUser(newUser);
  };

  const clearUser = () => {
    clearAuthData();
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser: updateUser,
        clearUser,
        loading,
        authChecked,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
